export default {
  // 导航栏
  navList: [
    {
      name: '产品介绍',
      href: '#introduce',
      active: true,
    },
    {
      name: '产品优势',
      href: '#advantage',
      active: false,
    },
    {
      name: '应用场景',
      href: '#scenario',
      active: false,
    },
    {
      name: '系统融合',
      href: '#merge',
      active: false,
    },
    {
      name: '客户案例',
      href: '#case',
      active: false,
    },
  ],
  // 产品介绍
  productIntroductionList: [
    {
      title: '便携式智能印章机',
      desc: '轻量型盖章设备，集安全、智能、便捷于一身支持多种用章模式，适用各种用印场景',
      text: '适用场景：外出办公、办公室',
      img: require('@/assets/images/landing-signet/cpjs_one.png')
    },
    {
      title: 'AI印控台',
      desc: '办公室固定场所用印，与便携式智能印章机搭配使用，更安全更高效',
      text: '适用场景：办公室等固定场所',
      img: require('@/assets/images/landing-signet/cpjs_two.png')
    },
  ],
  // 产品优势
  productAdvantageList: [
    {
      title: '无损兼容各类印章',
      descOne:'便携式智能印章机无需损坏原有印章，兼容红胶章、光敏章、回墨章、原子章、牛角章、铜章等',
      num: ' 99% ',
      descTwo: '以上的印章种类。',
      img: require('@/assets/images/landing-signet/cpys_one.png')
    },
    {
      title: '限定盖印范围',
      desc: '审批授权时可勾选限定印控台使用，便携式印章机在红外线电子围栏范围内自动解锁，可进行盖印，超出范围，无法解锁使用。',
      img: require('@/assets/images/landing-signet/cpys_two.png')
    },
    {
      title: '冗余双系统',
      desc: '可靠的身份识别方式，支持指纹识别离线盖印或直接盖印，无需PC/App/小程序。',
      img: require('@/assets/images/landing-signet/cpys_three.png')
    },
    {
      title: '自动二次补拍',
      desc: '通过自带高清摄像头，实时拍照、动态视频拍摄，全程记录用印信息上传云端。',
      img: require('@/assets/images/landing-signet/cpys_four.png')
    },
    {
      title: '实时记录，全程监控',
      desc: '通过自带高清摄像头，实时拍照、动态视频拍摄，全程记录用印信息上传云端。',
      img: require('@/assets/images/landing-signet/cpys_five.png')
    },
    {
      title: '用印全流程监控',
      desc: '文件、图片、视频、水印、OCR识别、数据等多维度监控手段，用印节点全程覆盖。',
      img: require('@/assets/images/landing-signet/cpys_six.png')
    },
  ],
  // 应用场景
  applicationScenariosList: [
    {
      title: '外带用印场景',
      descOne: '用印管理需求：1.印章经常性需要外带使用',
      descTwo: '2.分支机构投标、签约，需要使用总部印章',
      img: require('@/assets/images/landing-signet/yycj_one.png'),
      imgH5: require('@/assets/images/landing-signet/h5_yycj_one.png'),
    },
    {
      title: '固定用印场景',
      descOne: '用印管理需求：1.集团总部与分子公司日常办公固定用印',
      descTwo: '2.建立并管理日常办公数据库',
      img: require('@/assets/images/landing-signet/yycj_two.png'),
      imgH5: require('@/assets/images/landing-signet/h5_yycj_two.png'),
    },
    {
      title: '应急用印场景',
      descOne: '用印管理需求：1.应急用印无需走审批流程直接盖印',
      descTwo: '2.离线盖印并本机存储用印信息',
      img: require('@/assets/images/landing-signet/yycj_three.png'),
      imgH5: require('@/assets/images/landing-signet/h5_yycj_three.png'),
    },
  ],
  // 系统融合
  systemIntegrationList: [
    {
      title: '多系统无缝对接',
      content: [
        {
          icon: require('@/assets/images/landing-signet/xtrh_one_two.png'),
          tit: '企业微信',
          desc: '与微信端集成，满足不同组织规模的企业，在微信端直接单点登录后进行用印操作'
        },
        {
          icon: require('@/assets/images/landing-signet/xtrh_one_three.png'),
          tit: '钉钉',
          desc: '智能印章钉钉唯一深度合作伙伴，智能设备无缝对接现有流程，用印数据表单可以集成，可以直接调用H5页面显示'
        },
        {
          icon: require('@/assets/images/landing-signet/xtrh_one_four.png'),
          tit: 'OA门户',
          desc: '可以OA采购门户集成，集成后保留用户原有用印审批流程用印数 据表单可以集成可以直接调用H5页面显示'
        },
        {
          icon: require('@/assets/images/landing-signet/xtrh_one_five.png'),
          tit: 'SCM/ERP及其他第三方平台',
          desc: '为更多的用户提供更加安全，高效的印章全场景物电一体的服务'
        },
      ],
      img: '',
      imgH5: ''
    },
    {
      title: 'OA门户单点登录',
      img: require('@/assets/images/landing-signet/xtrh_two.png'),
      imgH5: require('@/assets/images/landing-signet/h5_xtrh_one.png'),
    },
    {
      title: '业务流程集成',
      img: require('@/assets/images/landing-signet/xtrh_three.png'),
      imgH5: require('@/assets/images/landing-signet/h5_xtrh_two.png'),
    },
    {
      title: 'H5菜单级集成',
      img: require('@/assets/images/landing-signet/xtrh_four.png'),
      imgH5: require('@/assets/images/landing-signet/h5_xtrh_three.png'),
    },
  ],
}